
//获取文档类型名称
export function getDocTypeName(fileName, contentType) {
    if (contentType && contentType.length > 0) {
        return getDocTypeNameWithContentType(contentType);
    }
    return getDocTypeNameWithDocName(fileName ?? "");
}

//根据文档类型获取文档类型名称
export function getDocTypeNameWithContentType(contentType) {
    switch (contentType) {
        case 'DOCUMENT':
            return "doc 文件";
        case 'WORD':
            return "Word 文件";
        case 'EXCEL':
            return "Excel 文件";
        case 'PPT':
            return "ppt 文件";
        case 'TXT':
            return "txt 文件";
        case 'HTML':
            return "Html 文件";
        case 'PDF':
            return "pdf 文件";
        case 'PIC':
            return "images 文件";
        case 'EXE':
            return "exe 文件";
        case 'ZIP':
            return "zip 文件";
        case 'AUDIO':
            return "audio 文件";
        case 'VIDEO':
            return "video 文件";
        case 'SKETCH':
            return "sketch 文件";
        case 'RP':
            return "rp 文件";
        case 'TTF':
            return "ttf 文件";
        case 'IPA':
            return "ipa 文件";
        case 'APK':
            return "apk 文件";
        case 'MARKDOWN':
            return "md 文件";
        case 'CODE':
            return "code 文件";
        case 'FOLDER':
            return '文件夹';
        default:
            return "未知 文件";
    }
}

//根据文档明湖曾获取文档类型名称
export function getDocTypeNameWithDocName(docName) {
    const docType = filterDocTypeWithDocName(docName);
    switch (docType) {
        case 'word':
            return "Word 文件";
        case 'excel':
            return "Excel 文件";
        case 'ppt':
            return "ppt 文件";
        case 'txt':
            return "txt 文件";
        case 'html':
            return "Html 文件";
        case 'pdf':
            return "pdf 文件";
        case 'img':
            return "images 文件";
        case 'exe':
            return "exe 文件";
        case 'zip':
            return "zip 文件";
        case 'audio':
            return "audio 文件";
        case 'video':
            return "video 文件";
        case 'sketch':
            return "sketch 文件";
        case 'rp':
            return "rp 文件";
        case 'ttf':
            return "ttf 文件";
        case 'ipa':
            return "ipa 文件";
        case 'apk':
            return "apk 文件";
        default:
            return "未知 文件";
    }
}

// 根据文档名称扩展后缀获取文档类型名称

const wordExtensionList = ["doc", "dot", "wps", "wpt", "docx", "dotx", "docm", "dotm", "rtf"];
const excelExtensionList = ["xls", "xlt", "et", "xlsx", "xltx", "xlsm", "xltm"];
const pptExtensionList = ["ppt", "pptx", "pptm", "ppsx", "ppsm", "pps", "potx", "potm", "dpt", "dps"];
const txtExtensionList = ["txt"];
const htmlExtensionList = ["html"];
const pdfExtensionList = ["pdf"];
const imgExtensionList = ["bmp", "gif", "jpg", "pic", "png", "jpeg", "heic"];
const exeExtensionList = ["exe", "dmg", "sys", "com"];
const zipExtensionList = ["rar", "zip", "gz"];
const audioExtensionList = ["wav", "aif", "au", "mp3"];
const videoExtensionList = ["mp4", "rmvb", "mkv", "avi", "mov"];
const sketchExtensionList = ["sketch"];
const rpExtensionList = ["rp"];
const ttfExtensionList = ["eot", "otf", "fon", "font", "ttf", "ttc", "woff"];
const ipaExtensionList = ["ipa"];
const apkExtensionList = ["apk"];
export function filterDocTypeWithDocName(docName) {
    const extension = (docName !== null && docName !== undefined && docName.includes(".") ? docName.split(".").pop() : docName) ?? "";

    const lowerEx = extension.toLowerCase();
    if (wordExtensionList.includes(lowerEx)) {
        return 'word';
    } else if (excelExtensionList.includes(lowerEx)) {
        return 'excel';
    } else if (pptExtensionList.includes(lowerEx)) {
        return 'ppt';
    } else if (txtExtensionList.includes(lowerEx)) {
        return 'txt';
    } else if (htmlExtensionList.includes(lowerEx)) {
        return 'html';
    } else if (pdfExtensionList.includes(lowerEx)) {
        return 'pdf';
    } else if (imgExtensionList.includes(lowerEx)) {
        return 'img';
    } else if (exeExtensionList.includes(lowerEx)) {
        return 'exe';
    } else if (zipExtensionList.includes(lowerEx)) {
        return 'zip';
    } else if (audioExtensionList.includes(lowerEx)) {
        return 'audio';
    } else if (videoExtensionList.includes(lowerEx)) {
        return 'video';
    } else if (sketchExtensionList.includes(lowerEx)) {
        return 'sketch';
    } else if (rpExtensionList.includes(lowerEx)) {
        return 'rp';
    } else if (ttfExtensionList.includes(lowerEx)) {
        return 'ttf';
    } else if (ipaExtensionList.includes(lowerEx)) {
        return 'ipa';
    } else if (apkExtensionList.includes(lowerEx)) {
        return 'apk';
    } else {
        return 'unknown';
    }
}